import initialState from '../../data/post';
import ActionTypes from '../constants/action-types';
// import store from '../../redux/reducers/reducer';

const postReducer = (state = initialState, action) => {
    let tmp;
    switch (action.type) {
        case ActionTypes.SET_ACTION:
            return {
                ...state,
                action: action.payload
            };
        case ActionTypes.GET_POSTS:
            return {
                ...state,
                posts: action.payload
            };
        case ActionTypes.SET_POSTS:
            return {
                ...state,
                posts: action.payload
            };
        case ActionTypes.SET_INITIALIZED:
            return {
                ...state,
                isInitialized: action.payload
            };
        case ActionTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case ActionTypes.APPEND_POSTS:
            return {
                ...state,
                posts: [...state.posts, ...action.payload]
            };
        case ActionTypes.SET_HAS_MORE:
            return {
                ...state,
                hasMore: action.payload
            };
        case ActionTypes.DELETE_POST: return {
            ...state,
            posts: [
                ...state.posts.filter(post => post.id != action.payload.id)
            ]
        };
        case ActionTypes.RESET_POSTS:
            return {
                ...state,
                posts: []
            };
        case ActionTypes.SET_SHOW_POST_ALBUM:
            return {
                ...state,
                showAlbum: action.payload
            };
        case ActionTypes.SET_POSTS_ACTIVE:
            return {
                ...state,
                selectedPost: action.payload
            };
        case ActionTypes.UPDATE_POST:
            tmp = [...action.payload.posts];

            const index = tmp.findIndex(t => t.id == action.payload.activePost.id);

            if (index >= 0) {
                tmp[index].medias = action.payload.activePost.medias;
                tmp[index].unlocked = action.payload.activePost.unlocked;
                return {
                    ...state,
                    posts: tmp
                };
            }

            return state;

        case ActionTypes.SET_POSTS_TOTAL_ALL:
            return {
                ...state,
                total_all: action.payload
            };

        case ActionTypes.SET_FEED: return { ...state, posts: action.payload };
        case ActionTypes.APPEND_FEED:
            return {
                ...state,
                posts: [...state.posts, ...action.payload]
            };
        case ActionTypes.UPDATE_FEED:
            let tmpFeed = [...action.payload.posts];

            const feedIndex = tmp.findIndex(t => t.id == action.payload.activePost.id);

            if (feedIndex >= 0) {
                tmpFeed[feedIndex].medias = action.payload.activePost.medias;
                tmpFeed[feedIndex].unlocked = action.payload.activePost.unlocked;
                return {
                    ...state,
                    posts: tmpFeed
                };
            }

            return state;

        case ActionTypes.CANCEL_POST_FETCH:
            return {
                ...state,
                cancelFetchPost: action.payload
            };

        case ActionTypes.SET_POST_IS_RESET:
            return {
                ...state,
                is_reset: action.payload
            };

        case ActionTypes.SET_POST_MEDIAS:
            return {
                ...state,
                postMedias: action.payload
            };

        case ActionTypes.SET_POST_GALLERY_ACTIVE:
            return {
                ...state,
                selectedPostGallery: action.payload
            };

        case ActionTypes.SET_POST:
            tmp = [...state.posts];
            const tmpIndex = tmp.findIndex(p => p.id == action.payload.id);

            if (tmpIndex >= 0) {
                tmp[tmpIndex] = action.payload;
            }

            return {
                ...state,
                posts: tmp
            };

        case ActionTypes.SET_POST_KW:
            return {
                ...state,
                keyword: action.payload
            };

        case ActionTypes.UPDATE_POST_BY_TYPE:
            tmp = [...state.posts];

            action.payload.forEach(post => {
                const index = tmp.findIndex(t => t.id == post.id);
                if (index >= 0) {
                    tmp[index] = post;
                }
            });

            return {
                ...state,
                posts: [...tmp]
            };

        case ActionTypes.POST_THANK_YOU:
            return {
                ...state,
                thankyou: action.payload
            };

        default: return state;
    }
};

export default postReducer;
